import React, { ReactNode } from 'react';
import { IconKakaoRegular, IconLinkRegular, IconShareAosBold, IconShareIosBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';
import { isBoolean } from 'lodash';

interface ProductShareProps {
  isIOS: boolean | null;
  isPreviewPath: boolean;
  is_kakao_share_feature_enabled: boolean;
  openShareSheet: (children: ReactNode) => void;
  copyShortUrl: () => void;
  shareWithKakao: () => void;
}

export const ProductShare: React.FC<React.PropsWithChildren<ProductShareProps>> = ({
  isIOS,
  isPreviewPath,
  is_kakao_share_feature_enabled,
  openShareSheet,
  copyShortUrl,
  shareWithKakao,
}) => {
  const handleShareClick = () => {
    openShareSheet(
      <ShareBottomSheetList>
        <li onClick={copyShortUrl}>
          <ShareButton type='button'>
            <IconLinkRegular />
            {'링크 복사하기'}
          </ShareButton>
        </li>
        {is_kakao_share_feature_enabled && (
          <li>
            <ShareButton type='button' onClick={shareWithKakao}>
              <IconKakaoRegular opacity={isPreviewPath ? '0.4' : '1'} />
              {'카카오톡 공유하기'}
            </ShareButton>
          </li>
        )}
      </ShareBottomSheetList>,
    );
  };

  return (
    <>
      <PdpShare aria-label='공유하기' onClick={handleShareClick}>
        {isBoolean(isIOS) &&
          (isIOS ? (
            <IconShareIosBold width={24} height={24} color='textTertiary' />
          ) : (
            <IconShareAosBold width={24} height={24} color='textTertiary' />
          ))}
      </PdpShare>
    </>
  );
};

const PdpShare = styled.button`
  position: relative;
  top: -1px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 42px;
  margin: 0;
  background: transparent;
  cursor: pointer;
`;

const ShareBottomSheetList = styled.ul`
  padding: 0 16px;
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);

  li {
    border-top: 1px solid ${vars.v3Color.gray100};

    &:first-of-type {
      border: none;
    }
  }
`;

const ShareButton = styled.button`
  width: 100%;
  height: 55px;
  display: flex;
  align-items: center;
  text-align: left;
  color: ${vars.color.textStrong};
  background: transparent;
`;
